import { render, staticRenderFns } from "./LegalDocumentSearchApplications.vue?vue&type=template&id=d16c7b3a&scoped=true&"
import script from "./LegalDocumentSearchApplications.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentSearchApplications.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentSearchApplications.vue?vue&type=style&index=0&id=d16c7b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16c7b3a",
  null
  
)

export default component.exports